<template>
  <div class="project-manager-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-flag"></i> Projects</span>
        <el-button icon="el-icon-plus" v-if="!readonlyMode" style="float: right;padding: 0" type="text" @click="showDialog('add')">Create Projects</el-button>
      </div>
      <div class="table-data-projects">
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="Active Projects" name="active"></el-tab-pane>
          <el-tab-pane label="Archived Projects" name="archived"></el-tab-pane>
        </el-tabs>
        <data-tables v-loading="loadingProject" :data="filteredData" border :page-size="20" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }">
          <el-table-column prop="project_name" label="Project Name" header-align="center" align="center"></el-table-column>
          <el-table-column prop="distribution_code" label="Distribution Code" header-align="center" align="center"></el-table-column>
          <el-table-column prop="created_date" label="Created" header-align="center" align="center"></el-table-column>
          <el-table-column prop="updated_date" label="Updated" header-align="center" align="center"></el-table-column>
          <el-table-column prop="uid" label="Action" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-button icon="el-icon-circle-check" type="primary" size="mini" @click="$router.push(`/project/${scope.row.uid}`)">View</el-button>
              <el-button icon="el-icon-edit" v-if="!readonlyMode" type="warning" size="mini" @click="showDialog('edit', scope.row.uid)">Edit</el-button>
              <el-button icon="el-icon-delete" v-if="!readonlyMode" type="danger" size="mini" @click="deleteProject(scope.row.uid)">Del</el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
    <ProjectCreateForm v-if="actionForm === 'add' && dialogFormVisible"  :companyUID="companyUID" :dialog-show.sync="dialogFormVisible" @on-submited="onSubmited"/>
    <ProjectEditForm v-if="actionForm === 'edit' && dialogFormVisible"  :companyUID="companyUID" :dialog-show.sync="dialogFormVisible" :formData="projectForm" @on-submited="onSubmited"/>
  </div>
</template>

<script>
import {getProjectByCompany, getProjectBy, delProject, getDistributionCode} from '@/api/project'
//import {getUserByCompany} from '@/api/user'
import ProjectCreateForm from "./create-form"
import ProjectEditForm from "./edit-form"
export default {
  components:{
    ProjectCreateForm,
    ProjectEditForm
  },
  props:{
    companyUID: String,
    readonlyMode:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      loadingProject: false,
      dataProjectTable: [],
      dialogFormVisible:false,
      actionForm: '',
      projectForm:{},
      activeTab: 'active'
    }
  },
  computed: {
    filteredData() {
      return this.dataProjectTable.filter(item => {
        if (this.activeTab === 'archived') {
          return item.is_archive == 1
        }
        return item.is_archive != 1
      })
    }
  },
  methods:{
    getProjectData(){
      this.loadingProject = true
      getProjectByCompany(this.companyUID).then(({result, data}) =>{
        this.loadingProject = false
        if(result){
          this.dataProjectTable = data
        }
      })
    },

    getProjectDataToEdit(uid){
      const loading = this.$notifyloading('Loading data...');
      getProjectBy(uid).then(({result, data}) =>{
        loading.close()
        if(result){
          this.projectForm = data
          this.dialogFormVisible = true
        }
      })
    },

    showDialog(action, uid){
      this.actionForm = action
      if(this.actionForm === 'add'){
        this.dialogFormVisible = true
      }else{
        this.getProjectDataToEdit(uid)
      } 
    },

    onSubmited(){
      this.getProjectData()
    },
    deleteProject(uid){
      this.$confirm('Are you sure you want to delete this Project, Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          delProject(uid).then(({result}) =>{
            if(result){
              this.$notify({
                title: 'Success',
                message: `Delete Project successfully`,
                type: 'success',
                duration: 2000
              });
              this.getProjectData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
  },
  created(){
    this.getProjectData()    
  }
}
</script>


<style lang="scss">
.project-manager-container{
  .el-checkbox {
    display: block;
  } 
}
</style>